// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IChecklistForm } from '~/utils/interface/checklist';

export const schema = (t: TFunction): yup.ObjectSchema<IChecklistForm> => {
  return yup.object().shape({
    businessId: yup.string().trim().optional(),
    businessType: yup.string().trim().optional(),
    title: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    type: yup.string().trim().optional(),
    isTemplate: yup.boolean().optional(),
    checklistItems: yup.array().optional(),
  });
};

export const defaultValuesForm: IChecklistForm = {
  businessId: EMPTY_STRING,
  businessType: EMPTY_STRING,
  title: EMPTY_STRING,
  type: EMPTY_STRING,
  isTemplate: false,
  checklistItems: [],
};
